import { useRef } from 'react';
import clsx from 'clsx';
import { AText, Box, Button } from '@alf/uikit';
import { useFixScroll, useIsNavMenuVisible } from '@namespace/common';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';
import {
  notificationCenterActions,
  useNotificationCenterStore
} from '../../store';
import { useGetMoreInfoAction } from '../Notification/useGetMoreInfoAction';

import styles from './index.module.css';

const { READ_NOTIFICATION, SKIP_NOTIFICATION } = notificationCenterActions;

export const CriticalNotification = () => {
  const { t } = useI18n();
  const rootRef = useRef();
  const criticalNotifications = useNotificationCenterStore(
    'criticalNotifications'
  );
  const [notification] = criticalNotifications;
  const { notificationId, notificationText } = notification;
  const moreInfoAction = useGetMoreInfoAction(notification);
  const hasMoreInfo = moreInfoAction != null;
  const isNavMenuVisible = useIsNavMenuVisible();

  useFixScroll('CriticalNotification', rootRef, true);

  const onMoreInfoClick = () => {
    READ_NOTIFICATION(notificationId);
    moreInfoAction();
  };

  const onCloseClick = () => {
    SKIP_NOTIFICATION(notificationId);
  };

  return (
    <>
      <Box className={styles.overlay} onClick={onCloseClick} />
      <Box
        direction="column"
        padding="ms m"
        gap="m"
        className={clsx([
          styles.root,
          isNavMenuVisible && styles.withBottomMenu
        ])}
        ref={rootRef}
      >
        <AText breed="R" size="l" color="txt_color_1" align="center">
          {notificationText}
        </AText>
        {hasMoreInfo && (
          <Button onClick={onMoreInfoClick}>
            {t('web.notifications.critical.read.btn')}
          </Button>
        )}
        <Box className={styles.close} padding="s">
          <Icon
            size="s"
            name="icons/general/action/close"
            color="txt_color_7"
            onClick={onCloseClick}
          />
        </Box>
      </Box>
    </>
  );
};
